import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { NbAuthService, NbAuthResult, NbTokenService, NbAuthOAuth2JWTToken } from '@nebular/auth';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { LogowanieService } from '../../../../@core/http/logowanie.service';
import { TokenResponse } from '../../../../shared/models/logowanie.model';

@Component({
  selector: 'ngx-callback-google',
  templateUrl: './callback-google.component.html',
})
export class CallbackGoogleComponent implements OnDestroy {

  private destroy$ = new Subject<void>();

  constructor(
    private authService: NbAuthService,
    private tokenService: NbTokenService,
    private logowanieService: LogowanieService,
    private router: Router) {

    this.authService.authenticate('google')
      .pipe(
        takeUntil(this.destroy$),
      )
      .subscribe((authResult: NbAuthResult) => {
        if (authResult.isSuccess()) {
          this.tokenService.clear().subscribe(() => {
            this.logowanieService.google(authResult.getToken().getPayload().access_token).subscribe(tokenResponse => {
              this.tokenService.set(this.getJWTToken(tokenResponse)).subscribe(() => {
                this.router.navigateByUrl('/pages/przychody-koszty');
              });
            });
          });
        } else {
          this.router.navigateByUrl('/login');
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private getJWTToken(tokenResponse: TokenResponse) {
    return new NbAuthOAuth2JWTToken(
      {
        'access_token': tokenResponse.token.access_token,
        'refresh_token': tokenResponse.token.refresh_token,
      },
      'google',
    );
  }
}
